import React, { useState } from 'react';
import { FaShieldAlt, FaUserShield, FaFire, FaBuilding, FaUsers, FaCheckCircle, FaBook, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaRunning, FaDumbbell, FaBalanceScale, FaFlag, FaAward, FaExclamationTriangle } from 'react-icons/fa';

const PoliceDefenceSafetyPage = () => {
  const [expandedPost, setExpandedPost] = useState(null);
  const [expandedState, setExpandedState] = useState(null);
  const [expandedPhysical, setExpandedPhysical] = useState(null);

  const posts = [
    {
      id: 'si',
      name: 'Sub-Inspector (SI)',
      icon: <FaUserShield />,
      grade: 'Gazetted Officer',
      eligibility: 'Bachelor\'s Degree (Any discipline)',
      ageLimit: '20-25 years (varies by state, relaxations available)',
      salary: '₹35,000 - ₹70,000/month',
      description: 'Supervises police station operations, crime investigation, law and order maintenance',
      examPattern: [
        { stage: 'Written Exam', type: 'Objective', duration: '2-3 hours', subjects: 'General Knowledge, Reasoning, Numerical Ability, General English/Hindi, State-specific topics' },
        { stage: 'Physical Test', type: 'PET/PST', duration: 'Varies', subjects: 'Running, High Jump, Long Jump, Shot Put (varies by state)' },
        { stage: 'Medical Exam', type: 'Medical Standards', duration: 'Varies', subjects: 'Physical fitness and medical examination' },
        { stage: 'Interview', type: 'Personality Test', duration: '15-30 mins', subjects: 'Communication, Awareness, Decision Making' }
      ],
      syllabus: {
        generalKnowledge: ['Indian History', 'Geography', 'Polity', 'Economy', 'Current Affairs', 'State-specific GK', 'Sports', 'Awards'],
        reasoning: ['Verbal Reasoning', 'Non-Verbal Reasoning', 'Logical Reasoning', 'Analytical Ability', 'Problem Solving'],
        numericalAbility: ['Arithmetic', 'Data Interpretation', 'Number Series', 'Simplification', 'Percentage', 'Ratio & Proportion'],
        englishHindi: ['Grammar', 'Vocabulary', 'Comprehension', 'Sentence Formation', 'Error Detection']
      },
      responsibilities: [
        'Crime investigation and case management',
        'Supervising police station operations',
        'Maintaining law and order',
        'Traffic management',
        'Court duty and case follow-up',
        'Team leadership and staff management',
        'Community policing initiatives',
        'VIP security arrangements'
      ],
      careerPath: 'Sub-Inspector → Inspector → Deputy Superintendent of Police (DSP) → Additional SP → Superintendent of Police (SP) → Deputy Inspector General (DIG) → Inspector General (IG) → Director General of Police (DGP)',
      stateVariations: {
        eligibility: 'Most states require Bachelor\'s degree; some accept 12th for certain categories',
        ageLimit: '20-25 years (general), up to 21-30 years in some states',
        examPattern: 'Similar structure but paper difficulty varies',
        physicalStandards: 'Height, chest vary by state and category',
        syllabus: '80% common, 20% state-specific'
      }
    },
    {
      id: 'constable',
      name: 'Police Constable',
      icon: <FaShieldAlt />,
      grade: 'Non-Gazetted',
      eligibility: '10th/12th Pass (varies by state)',
      ageLimit: '18-23 years (varies by state, relaxations available)',
      salary: '₹21,700 - ₹40,000/month',
      description: 'Front-line police personnel for maintaining law and order',
      examPattern: [
        { stage: 'Written Exam', type: 'Objective', duration: '1.5-2 hours', subjects: 'General Knowledge, Reasoning, Numerical Ability, General English/Hindi' },
        { stage: 'Physical Test', type: 'PET/PST', duration: 'Varies', subjects: 'Running, High Jump, Long Jump (varies by state)' },
        { stage: 'Medical Exam', type: 'Medical Standards', duration: 'Varies', subjects: 'Physical fitness and medical examination' },
        { stage: 'Document Verification', type: 'Verification', duration: 'Varies', subjects: 'Educational & caste certificates' }
      ],
      syllabus: {
        generalKnowledge: ['Basic Indian History', 'Geography', 'Polity', 'Current Affairs', 'State GK', 'Sports', 'General Science'],
        reasoning: ['Verbal Reasoning', 'Non-Verbal Reasoning', 'Series', 'Coding-Decoding', 'Blood Relations'],
        numericalAbility: ['Basic Arithmetic', 'Percentage', 'Ratio', 'Average', 'Time & Distance', 'Simple Interest'],
        englishHindi: ['Basic Grammar', 'Vocabulary', 'Comprehension']
      },
      responsibilities: [
        'Patrolling assigned areas',
        'Maintaining law and order',
        'Traffic control',
        'Crime prevention',
        'Public assistance',
        'Crowd management',
        'Beat duty',
        'Station duty support'
      ],
      careerPath: 'Constable → Head Constable → Assistant Sub-Inspector (ASI) → Sub-Inspector (through departmental exam/promotion)',
      stateVariations: {
        eligibility: 'Ranges from 10th pass to 12th pass',
        ageLimit: '18-23 years (general), varies up to 18-25 years',
        examPattern: 'Very similar across states',
        physicalStandards: 'Significant variation by state and category',
        syllabus: '90% common across states'
      }
    },
    {
      id: 'fire-officer',
      name: 'Fire Officer/Firefighter',
      icon: <FaFire />,
      grade: 'Non-Gazetted to Gazetted',
      eligibility: '10th/12th/Diploma (varies by post)',
      ageLimit: '18-25 years (varies by state)',
      salary: '₹25,000 - ₹60,000/month',
      description: 'Emergency response for fire incidents, rescue operations, disaster management',
      examPattern: [
        { stage: 'Written Exam', type: 'Objective', duration: '2 hours', subjects: 'General Knowledge, Reasoning, Numerical Ability, Fire Safety Knowledge' },
        { stage: 'Physical Test', type: 'PET/PST', duration: 'Varies', subjects: 'Running, Ladder Climbing, Hose Pulling, Equipment Handling' },
        { stage: 'Practical Test', type: 'Fire Equipment', duration: 'Varies', subjects: 'Fire equipment operation, rescue techniques' },
        { stage: 'Medical Exam', type: 'Medical Standards', duration: 'Varies', subjects: 'Physical & mental fitness examination' }
      ],
      syllabus: {
        generalKnowledge: ['General Science', 'Current Affairs', 'State GK', 'Fire Safety Basics'],
        reasoning: ['Verbal & Non-Verbal Reasoning', 'Series', 'Analogies', 'Problem Solving'],
        numericalAbility: ['Basic Mathematics', 'Arithmetic', 'Data Interpretation'],
        fireSafety: ['Fire Safety Principles', 'Fire Equipment Knowledge', 'First Aid', 'Rescue Techniques', 'Building Fire Codes']
      },
      responsibilities: [
        'Fire suppression and control',
        'Emergency rescue operations',
        'Fire safety inspections',
        'Public awareness programs',
        'Equipment maintenance',
        'Disaster response',
        'Training and drills',
        'Hazardous material handling'
      ],
      careerPath: 'Fireman → Leading Fireman → Sub-Officer → Station Officer → Divisional Officer → Chief Fire Officer',
      stateVariations: {
        eligibility: 'Varies from 10th to Diploma for different posts',
        ageLimit: '18-25 years generally',
        examPattern: 'Moderately similar, practical tests vary',
        physicalStandards: 'More stringent than police, varies by state',
        syllabus: '70% common, 30% state-specific fire codes'
      }
    },
    {
      id: 'jailor',
      name: 'Jailor/Prison Officer',
      icon: <FaBuilding />,
      grade: 'Gazetted Officer',
      eligibility: 'Bachelor\'s Degree',
      ageLimit: '21-30 years (varies by state)',
      salary: '₹35,000 - ₹65,000/month',
      description: 'Management of prison operations, inmate security, rehabilitation programs',
      examPattern: [
        { stage: 'Written Exam', type: 'Objective + Descriptive', duration: '3 hours', subjects: 'General Studies, Reasoning, Prison Law, Administration' },
        { stage: 'Physical Test', type: 'PET/PST', duration: 'Varies', subjects: 'Running, Physical Fitness' },
        { stage: 'Interview', type: 'Personality Test', duration: '30 mins', subjects: 'Leadership, Crisis Management, Ethics' },
        { stage: 'Medical Exam', type: 'Medical Standards', duration: 'Varies', subjects: 'Physical & mental fitness' }
      ],
      syllabus: {
        generalStudies: ['Indian Polity', 'Indian Constitution', 'Criminal Law', 'Prison Act', 'Human Rights', 'Social Justice'],
        reasoning: ['Logical Reasoning', 'Analytical Ability', 'Decision Making', 'Problem Solving'],
        administration: ['Prison Administration', 'Security Management', 'Rehabilitation Programs', 'Inmate Rights'],
        ethics: ['Ethics in Public Service', 'Case Studies', 'Ethical Dilemmas']
      },
      responsibilities: [
        'Prison administration and management',
        'Inmate security and safety',
        'Discipline maintenance',
        'Rehabilitation program supervision',
        'Staff management',
        'Court production arrangements',
        'Visitor management',
        'Emergency response'
      ],
      careerPath: 'Assistant Jailor → Deputy Jailor → Jailor → Superintendent (Jail) → Inspector General (Prisons) → Director General (Prisons)',
      stateVariations: {
        eligibility: 'Bachelor\'s degree required in all states',
        ageLimit: '21-30 years in most states',
        examPattern: 'Similar across states with local prison laws',
        physicalStandards: 'Moderate, similar to police',
        syllabus: '75% common, 25% state prison laws'
      }
    },
    {
      id: 'home-guard',
      name: 'Home Guard',
      icon: <FaUsers />,
      grade: 'Auxiliary Force',
      eligibility: '10th/12th Pass',
      ageLimit: '18-40 years (varies by state)',
      salary: '₹200-500 per duty (part-time) or ₹15,000-25,000 (full-time)',
      description: 'Auxiliary force to assist police in emergencies, disasters, and community service',
      examPattern: [
        { stage: 'Written Exam', type: 'Objective', duration: '2 hours', subjects: 'General Knowledge, Reasoning, Current Affairs' },
        { stage: 'Physical Test', type: 'PET', duration: 'Varies', subjects: 'Running, Basic Fitness' },
        { stage: 'Interview', type: 'Personal Interview', duration: '10-15 mins', subjects: 'General Awareness' },
        { stage: 'Training', type: 'Basic Training', duration: '2-4 weeks', subjects: 'Drill, Law, First Aid' }
      ],
      syllabus: {
        generalKnowledge: ['Current Affairs', 'State GK', 'Disaster Management', 'Civil Defence', 'Indian History'],
        reasoning: ['Basic Reasoning', 'Series', 'Coding-Decoding'],
        civicSense: ['Traffic Rules', 'Public Safety', 'Emergency Response', 'Community Service']
      },
      responsibilities: [
        'Assisting police during emergencies',
        'Traffic management',
        'Disaster relief operations',
        'Crowd control at events',
        'Community service',
        'Civil defence duties',
        'Fire fighting support',
        'Night patrolling assistance'
      ],
      careerPath: 'Home Guard Volunteer → Senior Home Guard → Home Guard Officer → District Home Guard Officer',
      stateVariations: {
        eligibility: '10th or 12th pass in different states',
        ageLimit: 'Most flexible: 18-40 years',
        examPattern: 'Highly similar across states',
        physicalStandards: 'Less stringent than regular police',
        syllabus: '95% common across states'
      }
    }
  ];

  const stateWiseComparison = {
    commonElements: [
      'Written examination (objective type)',
      'Physical Efficiency Test (PET)',
      'Physical Standard Test (PST)',
      'Medical Examination',
      'Document Verification',
      'Similar subject areas (GK, Reasoning, Math)',
      'Age relaxation for reserved categories',
      'Height and chest measurement standards',
      'Educational qualification requirements'
    ],
    variations: [
      'State-specific General Knowledge (20-30% weightage)',
      'Regional language requirements',
      'Physical standards (height/chest/weight)',
      'Marking scheme and negative marking',
      'Number of attempts allowed',
      'Interview/personality test inclusion',
      'Practical/skill tests for specialized posts',
      'Reservation policy implementation'
    ],
    similarityPercentage: {
      constable: '85-90% similar across states',
      si: '75-80% similar across states',
      fireOfficer: '70-75% similar across states',
      jailor: '75-80% similar across states',
      homeGuard: '90-95% similar across states'
    }
  };

  const physicalStandards = {
    male: {
      general: {
        height: '165-170 cm',
        chest: '79-84 cm (expanded)',
        weight: 'Proportionate to height',
        running: '1600m in 6.5-8 minutes (varies by state)'
      },
      obc: {
        height: '163-168 cm',
        chest: '77-82 cm',
        weight: 'Proportionate',
        running: '1600m in 6.5-8 minutes'
      },
      scst: {
        height: '160-165 cm',
        chest: '76-81 cm',
        weight: 'Proportionate',
        running: '1600m in 6.5-8 minutes'
      }
    },
    female: {
      general: {
        height: '155-160 cm',
        chest: 'Not applicable',
        weight: 'Proportionate to height',
        running: '1000m in 5.5-7 minutes (varies by state)'
      },
      obc: {
        height: '153-158 cm',
        chest: 'Not applicable',
        weight: 'Proportionate',
        running: '1000m in 5.5-7 minutes'
      },
      scst: {
        height: '150-155 cm',
        chest: 'Not applicable',
        weight: 'Proportionate',
        running: '1000m in 5.5-7 minutes'
      }
    },
    events: [
      { test: 'Running', male: '1600m / 5-10km', female: '800m-1000m / 2.5-5km' },
      { test: 'High Jump', male: '120-130 cm', female: '90-100 cm' },
      { test: 'Long Jump', male: '380-420 cm', female: '270-300 cm' },
      { test: 'Shot Put', male: '16 feet (7.26kg)', female: '12 feet (4kg)' }
    ],
    note: 'Standards vary significantly by state, post, and category. Refer to specific state notification.'
  };

  const majorStateRecruitments = [
    { state: 'Uttar Pradesh', body: 'UPPRPB', vacancies: '50,000+ annually', posts: 'Constable, SI, Jail Warder, Fireman' },
    { state: 'Maharashtra', body: 'MPSC', vacancies: '15,000+ annually', posts: 'Police Constable, SI, PSI, ASI' },
    { state: 'Rajasthan', body: 'RPSC', vacancies: '20,000+ annually', posts: 'Constable, SI, Sub-Inspector' },
    { state: 'Madhya Pradesh', body: 'MPPEB', vacancies: '10,000+ annually', posts: 'Constable, SI, Jail Prahari' },
    { state: 'Bihar', body: 'CSBC', vacancies: '15,000+ annually', posts: 'Police Constable, SI, Fireman' },
    { state: 'West Bengal', body: 'WBPRB', vacancies: '8,000+ annually', posts: 'Constable, SI, Lady Constable' },
    { state: 'Tamil Nadu', body: 'TNUSRB', vacancies: '10,000+ annually', posts: 'Police Constable, SI, Fireman' },
    { state: 'Karnataka', body: 'KSP', vacancies: '5,000+ annually', posts: 'Police Constable, PSI, PC' },
    { state: 'Gujarat', body: 'OJAS', vacancies: '8,000+ annually', posts: 'Police Constable, PSI, Talati' },
    { state: 'Haryana', body: 'HSSC', vacancies: '5,000+ annually', posts: 'Constable, SI, Male & Female' },
    { state: 'Punjab', body: 'PSSSB', vacancies: '3,000+ annually', posts: 'Constable, SI' },
    { state: 'Telangana', body: 'TSLPRB', vacancies: '5,000+ annually', posts: 'Police Constable, SI' },
    { state: 'Andhra Pradesh', body: 'APSLPRB', vacancies: '4,000+ annually', posts: 'Police Constable, SI, Fireman' },
    { state: 'Delhi', body: 'SSC Delhi', vacancies: '2,000+ annually', posts: 'Constable, SI, Head Constable' },
    { state: 'Assam', body: 'SLPRB Assam', vacancies: '5,000+ annually', posts: 'Constable, SI' }
  ];

  const preparationStrategy = [
    {
      phase: 'Physical Fitness (Ongoing - 6 months)',
      duration: 'Daily',
      activities: [
        'Start running practice immediately',
        'Build stamina gradually (2km → 5km)',
        'Practice high jump and long jump',
        'Strength training for shot put',
        'Maintain healthy diet',
        'Regular health check-ups'
      ]
    },
    {
      phase: 'Foundation Building (3 months)',
      duration: '3 Months',
      activities: [
        'Complete syllabus coverage',
        'NCERT books for GK (6-10)',
        'State-specific GK preparation',
        'Basic mathematics concepts',
        'Reasoning fundamentals',
        'English/Hindi grammar basics'
      ]
    },
    {
      phase: 'Practice Phase (2-3 months)',
      duration: '2-3 Months',
      activities: [
        'Previous year papers (10 years)',
        'State-specific mock tests',
        'Speed improvement drills',
        'Current affairs compilation',
        'Sectional tests',
        'Error analysis'
      ]
    },
    {
      phase: 'Final Preparation (1 month)',
      duration: '1 Month',
      activities: [
        'Full-length mock tests',
        'Revision of weak areas',
        'State GK intensive revision',
        'Physical fitness peak training',
        'Interview preparation',
        'Document preparation'
      ]
    }
  ];

  const benefits = [
    'Respectable government job with job security',
    'Regular salary with DA, HRA, and allowances',
    'Pension benefits after retirement',
    'Medical facilities for self and family',
    'Government quarters or HRA',
    'Leave Travel Concession',
    'Children education allowance',
    'Uniform and equipment provided',
    'Provident Fund benefits',
    'Promotion opportunities',
    'Service in home state (most states)',
    'Social respect and prestige',
    'Adventure and variety in work',
    'Opportunity to serve society',
    'Training and skill development',
    'Martyrdom benefits for family'
  ];

  const features = [
    {
      icon: <FaBook />,
      title: 'State-wise Preparation',
      description: 'Specialized courses for each state police recruitment with local GK'
    },
    {
      icon: <FaDumbbell />,
      title: 'Physical Training',
      description: 'Dedicated physical fitness training with professional coaches'
    },
    {
      icon: <FaLaptop />,
      title: 'Online Test Series',
      description: 'State-specific mock tests matching actual exam patterns'
    },
    {
      icon: <FaClock />,
      title: 'Time Management',
      description: 'Strategies to complete exam within time limits'
    },
    {
      icon: <FaTrophy />,
      title: 'Interview Preparation',
      description: 'Mock interviews and personality development for SI posts'
    },
    {
      icon: <FaAward />,
      title: 'Success Track Record',
      description: 'Proven methodology with thousands of selected candidates'
    }
  ];

  const togglePost = (id) => {
    setExpandedPost(expandedPost === id ? null : id);
  };

  const toggleState = (category) => {
    setExpandedState(expandedState === category ? null : category);
  };

  const togglePhysical = (category) => {
    setExpandedPhysical(expandedPhysical === category ? null : category);
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Hero Section */}
      <div className="text-white py-5 my-5" style={{ background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-3">Police, Defence & Safety Services</h1>
              <p className="lead mb-4">
                Comprehensive training for State Police Recruitment - SI, Constable, Fire Officer, Jailor, Home Guard. Join the force that protects and serves the nation with honor, courage, and commitment.
              </p>
              <button className="btn btn-light btn-lg px-4 me-3">Start Training</button>
              <button className="btn btn-outline-light btn-lg px-4">View State Exams</button>
            </div>
            <div className="col-lg-4 text-center">
              <FaShieldAlt size={150} className="opacity-75" />
            </div>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="container py-4">
        <div className="row g-4">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-primary fw-bold mb-1">2 Lakh+</h3>
              <p className="text-muted mb-0">Annual Vacancies</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-success fw-bold mb-1">29 States + UT zones</h3>
              <p className="text-muted mb-0">Recruiting</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-info fw-bold mb-1">₹22K-70K</h3>
              <p className="text-muted mb-0">Salary Range/Month</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-warning fw-bold mb-1">10th/12th</h3>
              <p className="text-muted mb-0">Minimum Qualification</p>
            </div>
          </div>
        </div>
      </div>

      {/* Similarity Alert */}
      <div className="container py-4">
        <div className="alert alert-info border-0 shadow-sm">
          <div className="d-flex align-items-center">
            <FaExclamationTriangle size={30} className="me-3 text-info" />
            <div>
              <h5 className="mb-2 fw-bold">Exam Pattern Similarity Across States</h5>
              <p className="mb-0">Police recruitment exams follow similar patterns across all Indian states with <strong>75-90% common syllabus</strong>. The main differences are in state-specific GK (20-30%), physical standards, and regional language requirements. Once prepared for one state, you can easily appear for other state exams with minimal additional preparation!</p>
            </div>
          </div>
        </div>
      </div>

      {/* Posts & Positions */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Major Posts in Police & Safety Services</h2>
        <div className="row">
          <div className="col-12">
            {posts.map((post) => (
              <div key={post.id} className="card mb-3 border-0 shadow-sm">
                <div 
                  className="card-header bg-light d-flex justify-content-between align-items-center"
                  onClick={() => togglePost(post.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div className="text-primary me-3" style={{ fontSize: '2rem' }}>
                      {post.icon}
                    </div>
                    <div>
                      <h5 className="mb-1 fw-bold text-primary">{post.name}</h5>
                      <small className="text-muted">{post.description}</small>
                    </div>
                  </div>
                  {expandedPost === post.id ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {expandedPost === post.id && (
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Eligibility:</strong></p>
                        <p className="text-muted small">{post.eligibility}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Age Limit:</strong></p>
                        <p className="text-muted small">{post.ageLimit}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Salary:</strong></p>
                        <p className="text-success fw-bold small">{post.salary}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Grade:</strong></p>
                        <p className="text-info small">{post.grade}</p>
                      </div>
                    </div>

                    <h6 className="fw-bold mb-3">Examination Pattern:</h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered">
                        <thead className="table-light">
                          <tr>
                            <th>Stage</th>
                            <th>Type</th>
                            <th>Duration</th>
                            <th>Subjects/Tests</th>
                          </tr>
                        </thead>
                        <tbody>
                          {post.examPattern.map((pattern, idx) => (
                            <tr key={idx}>
                              <td className="fw-semibold">{pattern.stage}</td>
                              <td>{pattern.type}</td>
                              <td>{pattern.duration}</td>
                              <td><small>{pattern.subjects}</small></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <h6 className="fw-bold mb-3">Syllabus:</h6>
                    <div className="row g-3">
                      {Object.entries(post.syllabus).map(([key, topics], idx) => (
                        <div key={idx} className="col-md-6">
                          <div className="card border-0 bg-light h-100">
                            <div className="card-body p-3">
                              <h6 className="text-primary mb-2">{key.replace(/([A-Z])/g, ' $1').trim().toUpperCase()}</h6>
                              <div className="d-flex flex-wrap gap-1">
                                {topics.map((topic, tIdx) => (
                                  <span key={tIdx} className="badge bg-secondary small">{topic}</span>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="mt-4">
                      <h6 className="fw-bold mb-3">Key Responsibilities:</h6>
                      <div className="row">
                        {post.responsibilities.map((resp, idx) => (
                          <div key={idx} className="col-md-6 mb-2">
                            <FaCheckCircle className="text-success me-2" size={12} />
                            <small>{resp}</small>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mt-4 alert alert-primary">
                      <strong>Career Path:</strong> {post.careerPath}
                    </div>

                    <div className="mt-3">
                      <h6 className="fw-bold mb-3">State-wise Variations:</h6>
                      <div className="table-responsive">
                        <table className="table table-sm">
                          <tbody>
                            {Object.entries(post.stateVariations).map(([key, value], idx) => (
                              <tr key={idx}>
                                <td className="fw-semibold" style={{ width: '30%' }}>{key.replace(/([A-Z])/g, ' $1').trim()}</td>
                                <td><small>{value}</small></td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Similarity Across States */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">How Similar Are Exams Across States?</h2>
          
          <div className="row mb-5">
            <div className="col-12">
              <div className="card border-0 shadow">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0 fw-bold">Common Elements Across All States (75-95%)</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    {stateWiseComparison.commonElements.map((element, idx) => (
                      <div key={idx} className="col-md-6 mb-3">
                        <FaCheckCircle className="text-success me-2" />
                        <strong>{element}</strong>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-12">
              <div className="card border-0 shadow">
                <div className="card-header bg-warning text-dark">
                  <h5 className="mb-0 fw-bold">Key Variations Across States (5-25%)</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    {stateWiseComparison.variations.map((variation, idx) => (
                      <div key={idx} className="col-md-6 mb-3">
                        <FaExclamationTriangle className="text-warning me-2" />
                        {variation}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <h4 className="text-center mb-4 fw-bold">Similarity Percentage by Post</h4>
              <div className="row g-3">
                {Object.entries(stateWiseComparison.similarityPercentage).map(([key, value], idx) => (
                  <div key={idx} className="col-md-6 col-lg-4">
                    <div className="card border-0 shadow-sm text-center p-4">
                      <h6 className="fw-bold text-primary">{key.replace(/([A-Z])/g, ' $1').trim().toUpperCase()}</h6>
                      <div className="progress my-3" style={{ height: '25px' }}>
                        <div 
                          className="progress-bar bg-success" 
                          role="progressbar" 
                          style={{ width: value.split('%')[0] + '%' }}
                          aria-valuenow={value.split('%')[0]} 
                          aria-valuemin="0" 
                          aria-valuemax="100"
                        >
                          <strong>{value.split(' ')[0]}</strong>
                        </div>
                      </div>
                      <p className="text-muted small mb-0">{value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="alert alert-success mt-5">
            <h5 className="fw-bold mb-3">💡 Key Insight for Aspirants:</h5>
            <p className="mb-2">If you prepare thoroughly for <strong>one state police exam</strong>, you can appear for <strong>multiple state exams</strong> with just 2-3 weeks of additional preparation for state-specific GK!</p>
            <p className="mb-0"><strong>Example:</strong> A candidate prepared for UP Police can easily appear for Bihar, MP, Rajasthan, Haryana police exams by just focusing on respective state GK.</p>
          </div>
        </div>
      </div>

      {/* Physical Standards */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Physical Standards & Tests</h2>
        
        <div className="row g-4 mb-4">
          <div className="col-md-6">
            <div className="card border-0 shadow h-100">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0 fw-bold">Male Candidates - Physical Standards</h5>
              </div>
              <div className="card-body">
                {Object.entries(physicalStandards.male).map(([category, standards], idx) => (
                  <div key={idx} className="mb-3">
                    <h6 className="text-primary fw-bold text-uppercase">{category}</h6>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td><strong>Height:</strong></td>
                          <td>{standards.height}</td>
                        </tr>
                        <tr>
                          <td><strong>Chest:</strong></td>
                          <td>{standards.chest}</td>
                        </tr>
                        <tr>
                          <td><strong>Weight:</strong></td>
                          <td>{standards.weight}</td>
                        </tr>
                        <tr>
                          <td><strong>Running:</strong></td>
                          <td>{standards.running}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card border-0 shadow h-100">
              <div className="card-header bg-danger text-white">
                <h5 className="mb-0 fw-bold">Female Candidates - Physical Standards</h5>
              </div>
              <div className="card-body">
                {Object.entries(physicalStandards.female).map(([category, standards], idx) => (
                  <div key={idx} className="mb-3">
                    <h6 className="text-danger fw-bold text-uppercase">{category}</h6>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td><strong>Height:</strong></td>
                          <td>{standards.height}</td>
                        </tr>
                        <tr>
                          <td><strong>Chest:</strong></td>
                          <td>{standards.chest}</td>
                        </tr>
                        <tr>
                          <td><strong>Weight:</strong></td>
                          <td>{standards.weight}</td>
                        </tr>
                        <tr>
                          <td><strong>Running:</strong></td>
                          <td>{standards.running}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="card border-0 shadow">
          <div className="card-header bg-info text-white">
            <h5 className="mb-0 fw-bold">Physical Efficiency Test (PET) Events</h5>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Test Event</th>
                    <th>Male Candidates</th>
                    <th>Female Candidates</th>
                  </tr>
                </thead>
                <tbody>
                  {physicalStandards.events.map((event, idx) => (
                    <tr key={idx}>
                      <td className="fw-semibold">{event.test}</td>
                      <td>{event.male}</td>
                      <td>{event.female}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="alert alert-warning mt-3">
              <strong>Important Note:</strong> {physicalStandards.note}
            </div>
          </div>
        </div>
      </div>

      {/* Major State Recruitments */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">State-wise Police Recruitment Overview</h2>
          <div className="table-responsive">
            <table className="table table-hover bg-white shadow-sm">
              <thead className="table-dark">
                <tr>
                  <th>State</th>
                  <th>Recruiting Body</th>
                  <th>Annual Vacancies</th>
                  <th>Major Posts</th>
                </tr>
              </thead>
              <tbody>
                {majorStateRecruitments.map((state, idx) => (
                  <tr key={idx}>
                    <td className="fw-bold">{state.state}</td>
                    <td>{state.body}</td>
                    <td className="text-success fw-semibold">{state.vacancies}</td>
                    <td><small>{state.posts}</small></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="text-center mt-4">
            <p className="text-muted">
              <strong>Total Combined Vacancies:</strong> Approximately 2+ lakh positions across all states annually
            </p>
          </div>
        </div>
      </div>

      {/* Preparation Strategy */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Complete Preparation Strategy</h2>
        <div className="row g-4">
          {preparationStrategy.map((phase, idx) => (
            <div key={idx} className="col-md-6">
              <div className="card border-0 shadow h-100">
                <div className="card-header bg-gradient text-white" style={{ background: `linear-gradient(135deg, ${['#667eea', '#f093fb', '#4facfe', '#43e97b'][idx]} 0%, ${['#764ba2', '#f5576c', '#00f2fe', '#38f9d7'][idx]} 100%)` }}>
                  <h5 className="mb-1 fw-bold">{phase.phase}</h5>
                  <small>{phase.duration}</small>
                </div>
                <div className="card-body">
                  <h6 className="fw-bold mb-3">Key Activities:</h6>
                  <ul className="list-unstyled">
                    {phase.activities.map((activity, aIdx) => (
                      <li key={aIdx} className="mb-2">
                        <FaCheckCircle className="text-success me-2" />
                        {activity}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Physical Training Tips */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Physical Fitness Training Guide</h2>
          <div className="row g-4">
            <div className="col-md-6">
              <div className="card border-success h-100">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0">Running & Stamina Building</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-3">
                      <strong>Week 1-2:</strong> Start with 1-2 km daily jogging
                    </li>
                    <li className="mb-3">
                      <strong>Week 3-6:</strong> Increase to 3-4 km with interval training
                    </li>
                    <li className="mb-3">
                      <strong>Week 7-12:</strong> Build up to 5-6 km with speed work
                    </li>
                    <li className="mb-3">
                      <strong>Month 4-6:</strong> Focus on timing - run 1600m under 6.5 minutes
                    </li>
                    <li className="mb-3">
                      <strong>Tips:</strong> Run in the morning, wear proper shoes, stay hydrated
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card border-info h-100">
                <div className="card-header bg-info text-white">
                  <h5 className="mb-0">Jumping & Strength Training</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-3">
                      <strong>High Jump:</strong> Practice scissor jump technique, leg strengthening exercises
                    </li>
                    <li className="mb-3">
                      <strong>Long Jump:</strong> Sprint practice, explosive leg power, proper landing technique
                    </li>
                    <li className="mb-3">
                      <strong>Shot Put:</strong> Upper body strength, shoulder exercises, technique practice
                    </li>
                    <li className="mb-3">
                      <strong>Exercises:</strong> Squats, lunges, calf raises, push-ups, pull-ups
                    </li>
                    <li className="mb-3">
                      <strong>Recovery:</strong> Adequate rest, stretching, proper nutrition
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Benefits */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Career Benefits in Police & Safety Services</h2>
        <div className="row g-3">
          {benefits.map((benefit, idx) => (
            <div key={idx} className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body d-flex align-items-center p-3">
                  <FaCheckCircle className="text-success me-3 flex-shrink-0" size={20} />
                  <p className="mb-0">{benefit}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Features */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Why Choose Our Training?</h2>
          <div className="row g-4">
            {features.map((feature, idx) => (
              <div key={idx} className="col-md-4">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <div className="text-primary mb-3" style={{ fontSize: '3rem' }}>
                    {feature.icon}
                  </div>
                  <h5 className="fw-bold mb-3">{feature.title}</h5>
                  <p className="text-muted">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Success Mantras */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Success Mantras for Police Exams</h2>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <FaDumbbell size={50} className="text-primary mb-3" />
              <h5 className="fw-bold mb-3">Physical Fitness First</h5>
              <p className="text-muted">Start physical training from day one. It takes 6 months to build required stamina and strength.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <FaBook size={50} className="text-success mb-3" />
              <h5 className="fw-bold mb-3">Smart Study Plan</h5>
              <p className="text-muted">Focus on common topics (70%) and state-specific GK (30%). Use previous year papers effectively.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <FaFlag size={50} className="text-info mb-3" />
              <h5 className="fw-bold mb-3">Multiple Attempts</h5>
              <p className="text-muted">Apply for multiple states. Similarity in exams allows you to maximize your chances of selection.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Important Books */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Recommended Study Materials</h2>
          <div className="row g-4">
            <div className="col-md-6">
              <div className="card border-0 shadow h-100">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0">For Written Examination</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-2">📚 Lucent's General Knowledge (Hindi/English)</li>
                    <li className="mb-2">📚 R.S. Aggarwal - Quantitative Aptitude</li>
                    <li className="mb-2">📚 R.S. Aggarwal - Reasoning</li>
                    <li className="mb-2">📚 Wren & Martin - English Grammar</li>
                    <li className="mb-2">📚 NCERT Books (Class 6-10) for basics</li>
                    <li className="mb-2">📚 State-specific GK book (respective state)</li>
                    <li className="mb-2">📚 Previous 10 years question papers</li>
                    <li className="mb-2">📚 Current Affairs Monthly Magazine</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card border-0 shadow h-100">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0">For State-Specific Preparation</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-2">📚 State History book (respective state)</li>
                    <li className="mb-2">📚 State Geography atlas</li>
                    <li className="mb-2">📚 State Polity and Governance</li>
                    <li className="mb-2">📚 State Economy and Budget</li>
                    <li className="mb-2">📚 State Current Affairs</li>
                    <li className="mb-2">📚 State Folk Culture and Heritage</li>
                    <li className="mb-2">📚 State Government Schemes</li>
                    <li className="mb-2">📚 State Famous Personalities</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Medical Standards */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Medical Standards</h2>
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card border-0 shadow h-100">
              <div className="card-header bg-warning text-dark">
                <h5 className="mb-0">Essential Medical Requirements</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <FaCheckCircle className="text-success me-2" />
                    <strong>Vision:</strong> 6/6 or 6/9 with correctable vision (varies by post)
                  </li>
                  <li className="mb-3">
                    <FaCheckCircle className="text-success me-2" />
                    <strong>No Color Blindness:</strong> Mandatory for all police posts
                  </li>
                  <li className="mb-3">
                    <FaCheckCircle className="text-success me-2" />
                    <strong>No Flat Foot:</strong> Proper foot arch required
                  </li>
                  <li className="mb-3">
                    <FaCheckCircle className="text-success me-2" />
                    <strong>No Knock Knee:</strong> Straight legs required
                  </li>
                  <li className="mb-3">
                    <FaCheckCircle className="text-success me-2" />
                    <strong>No Varicose Veins:</strong> Healthy blood circulation
                  </li>
                  <li className="mb-3">
                    <FaCheckCircle className="text-success me-2" />
                    <strong>Hearing:</strong> Normal hearing in both ears
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-0 shadow h-100">
              <div className="card-header bg-danger text-white">
                <h5 className="mb-0">Disqualifying Conditions</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <FaExclamationTriangle className="text-danger me-2" />
                    Any form of heart disease
                  </li>
                  <li className="mb-3">
                    <FaExclamationTriangle className="text-danger me-2" />
                    Tuberculosis or respiratory issues
                  </li>
                  <li className="mb-3">
                    <FaExclamationTriangle className="text-danger me-2" />
                    Diabetes or blood sugar issues
                  </li>
                  <li className="mb-3">
                    <FaExclamationTriangle className="text-danger me-2" />
                    Epilepsy or seizure disorders
                  </li>
                  <li className="mb-3">
                    <FaExclamationTriangle className="text-danger me-2" />
                    Hernia or abdominal issues
                  </li>
                  <li className="mb-3">
                    <FaExclamationTriangle className="text-danger me-2" />
                    Any permanent physical deformity
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container py-5">
        <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)' }}>
          <div className="card-body text-white text-center p-5">
            <h2 className="fw-bold mb-3">Ready to Serve the Nation?</h2>
            <p className="lead mb-4">
              Join our comprehensive training program for Police, Defence & Safety Services across all states
            </p>
            <button className="btn btn-light btn-lg px-5 me-3">Start Training Today</button>
            <button className="btn btn-outline-light btn-lg px-5">Book Free Counseling</button>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default PoliceDefenceSafetyPage;